import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}`

export default {
    Obter(filtro) {
        let numeroLicitacaoTratado = filtro.numeroLicitacao
        ? filtro.numeroLicitacao.replace(/\//g, '-')
        : '';
        
        let queryParam = `${numeroLicitacaoTratado ? `numeroLicitacao=${numeroLicitacaoTratado}&` : ''}`;
        queryParam += `${filtro.status ? `status=${filtro.status}&` : ''}`;

        return axiosJwt
            .get(`${api}/propostas-precos?${queryParam}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    ObterPorId(propostaPrecoId) {
        return axiosJwt
            .get(`${api}/propostas-precos/${propostaPrecoId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    Adicionar(propostaPreco) {
        const formData = new FormData()
        formData.append('numeroLicitacao', propostaPreco.numeroLicitacao)
        formData.append('objetoContratacao', propostaPreco.objetoContratacao)
        formData.append('tipoContrato', propostaPreco.tipoContrato)
        formData.append('encargosSociais', propostaPreco.encargosSociais)
        formData.append('bancos', propostaPreco.bancos)
        formData.append('planilha', propostaPreco.planilha)

        return axiosJwt
            .post(`${api}/propostas-precos`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
            .then(response => {
                return response
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    Atualizar(propostaPreco) {
        const formData = new FormData()
        formData.append('propostaPrecoId', propostaPreco.propostaPrecoId)
        formData.append('numeroLicitacao', propostaPreco.numeroLicitacao)
        formData.append('objetoContratacao', propostaPreco.objetoContratacao)
        formData.append('tipoContrato', propostaPreco.tipoContrato)
        formData.append('encargosSociais', propostaPreco.encargosSociais)
        formData.append('bancos', propostaPreco.bancos)
        formData.append('planilha', propostaPreco.planilha)

        return axiosJwt
            .put(`${api}/propostas-precos`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
            .then(response => {
                return response
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    Excluir(propostaPrecoId) {
        return axiosJwt
            .delete(`${api}/propostas-precos/${propostaPrecoId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    VincularFornecedor(propostaPrecoId, fornecedorId) {
        return axiosJwt
            .post(`${api}/propostas-precos/${propostaPrecoId}/fornecedor-vencedor/${fornecedorId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    RegistrarTentativaVinculoCnpjNaoEncontrado(propostaPrecoId, cnpj) {
        return axiosJwt
            .post(`${api}/propostas-precos/${propostaPrecoId}/tentativa-vinculo-cnpj-nao-encontrado?cnpj=${cnpj}`)
            .catch(error => {
                return errorHandler(error)
            })
    },

    AtualizarPrecoItens(propostaPrecoId, dto) {
        return axiosJwt
            .put(`${api}/propostas-precos/${propostaPrecoId}/atualizar-precos`, dto)
            .then(response => {
                return response
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    Finalizar(propostaPrecoId) {
        return axiosJwt
            .post(`${api}/propostas-precos/${propostaPrecoId}/finalizar`)
            .then(response => {
                return response
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    InabilitarFornecedor(propostaPrecoId, dto) {
        const formData = new FormData();
        formData.append("NotaTecnica", dto.notaTecnica);

        return axiosJwt
            .put(`${api}/propostas-precos/${propostaPrecoId}/inabilitar-fornecedor`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    SolicitarDiligenciaFornecedor(propostaPrecoId, dto) {
        const formData = new FormData();
        formData.append('Justificativa', dto.justificativa);
        formData.append('NotaTecnica', dto.notaTecnica);

        return axiosJwt
            .put(`${api}/propostas-precos/${propostaPrecoId}/solicitar-diligencia`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    HabilitarFornecedor(propostaPrecoId, dto) {
        const formData = new FormData();
        formData.append('DataBaseReajustamento', dto.dataBaseReajustamento);
        if (dto.justificativa) formData.append('Justificativa', dto.justificativa);
        formData.append('NotaTecnica', dto.notaTecnica);

        return axiosJwt
            .put(`${api}/propostas-precos/${propostaPrecoId}/habilitar-fornecedor`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    AtualizarDataBaseReajustamento(propostaPrecoId, dto) {
        return axiosJwt
            .put(`${api}/propostas-precos/${propostaPrecoId}/atualizar-data-base-reajustamento`, dto)
            .then(response => {
                return response
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    Exportar(propostaPrecoId) {
        return axiosJwt
            .get(`${api}/propostas-precos/${propostaPrecoId}/exportar`, {
                responseType: 'blob',
            })
            .then(response => {
                return response
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    DownloadHistoricoAnexo(propostaPrecoId, propostaPrecoHistoricoAnexoId) {
        return axiosJwt
            .get(`${api}/propostas-precos/${propostaPrecoId}/historico/anexos/${propostaPrecoHistoricoAnexoId}/download`, {
                responseType: 'blob',
            })
            .then(response => {
                return response
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
}
